module.exports = __webpack_public_path__ + "img/pin_tuan_desc.326f15ec.png";